import {
  Stack,
  IContextualMenuProps,
  IIconProps,
  CommandButton,
  PrimaryButton,
  TextField,
  Text,
  IImageProps,
  Modal
} from '@fluentui/react';
import { CloseIcon, Avatar } from '@fluentui/react-northstar';
import React, { useEffect, useState } from 'react';
import { SidePanelTypes } from './SidePanel';
import { apiServices } from '../../services/ApiServices';
import img from '../../assets/MicrosoftTeams-image.png';
import { MAXIMUM_LENGTH_OF_MESSAGE } from '../../constants';
import {
  chatHeaderBoxStyle,
  cardStyle,
  textStyle,
  chatBtn,
  selectStyle,
  contentStyles
} from '../styles/StartScreen/ChatHeader.styles';
import Component from '../../assets/Component 1.png';

import { useHistory } from 'react-router-dom';
import { ChatHeaderDispatchProps, ChatHeaderProps } from '../../containers/ChatHeader';
import { useSelector } from 'react-redux';
import { getIsAuthenticated } from '../../selectors/getIsAuthenticated';
type ChatHeaderPaneProps = {
  selectedPane?: SidePanelTypes;
  disabled?: boolean;
  checked?: boolean;
  setAdminFncType(threadId: number): void;
};
const imageProps: IImageProps = {
  maximizeFrame: true,
  src: img
};

export default (props: ChatHeaderDispatchProps & ChatHeaderProps & ChatHeaderPaneProps): JSX.Element => {
  const capacityExpansion = (e: any, index: any) => {
    props.setAdminFncType(index.index);
  };
  const personalExpansion = (e: any, index: any) => {
    // setIsMenuOpen2(!isMenuOpen2);
    if (index.index == 1) {
      setShowcard(!showCard);
    } else {
      props.setAdminFncType(4);
    }
  };
  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: 'ticket',
        index: 1,
        content: '监控',
        text: '监控',
        onClick: capacityExpansion
      },
      {
        key: 'log',
        index: 2,
        content: '管理员日志',
        text: '管理员日志',
        onClick: capacityExpansion
      },

      {
        key: 'service',
        index: 3,
        content: '服务设置',
        text: '服务设置',
        onClick: capacityExpansion
      }
    ]
  };
  const personalCenterItems: IContextualMenuProps = {
    items: [
      {
        key: 'Setup',
        index: 1,
        content: '个人设置',
        text: '个人设置',
        onClick: personalExpansion
      },
      {
        key: 'personalLog',
        index: 2,
        text: '个人日志',
        content: '个人日志',
        onClick: personalExpansion
      }
    ]
  };
  const itemsState: IContextualMenuProps = {
    items: [
      {
        key: 'active',
        index: 1,
        content: '客服在线',
        text: '客服在线',
        iconProps: { iconName: 'SkypeCircleCheck', styles: { root: { color: 'green !important' } } },
        onClick: (e, index: any) => {
          setActiveIndex(index);
          apiServices.postChangeStatus({ status: index.index });
        }
      },
      {
        key: 'offine',
        index: 0,
        content: '客服离线',
        text: '客服离线',
        iconProps: { iconName: 'SkypeCircleMinus', styles: { root: { color: 'red !important' } } },
        onClick: (e, index: any) => {
          setActiveIndex(index);
          apiServices.postChangeStatus({ status: index.index });
        }
      },

      {
        key: 'Leave',
        index: 2,
        content: '客服离开',
        text: '客服离开',
        iconProps: { iconName: 'SkypeCircleClock', styles: { root: { color: '#ffbb00 !important' } } },
        onClick: (e, index: any) => {
          setActiveIndex(index);
          apiServices.postChangeStatus({ status: index.index });
        }
      }
    ]
  };

  const [activeIndex, setActiveIndex] = useState<any>(itemsState.items[1]);

  const [showCard, setShowcard] = useState(false);
  const [isMenuOpen1, setIsMenuOpen1] = useState(false);
  const [isMenuOpen2, setIsMenuOpen2] = useState(false);
  const [isMenuOpen3, setIsMenuOpen3] = useState(false);
  const [isBlur, setIsBlur] = useState<any>(false);

  const [defaultName, setDefaultName] = useState('');
  const [defaultWelcomeWords, setDefaultWelcomeWords] = useState('');
  const [nickName, setNickName] = useState('');
  const [avatarUrl, setAvatarUrl] = useState('');
  const [welcomeWords, setWelcomeWords] = useState('');
  const [isAdmin, setisAdmin] = useState(false);

  const loadPage = async () => {
    let userSettingsInfo = await apiServices.getUserSettings();

    if (userSettingsInfo?.status === 0 && !userSettingsInfo.result?.nickName) {
      // 新用户默认展开用户设置
      setShowcard(true);
      setActiveIndex(itemsState.items[0]);
    }
    if (userSettingsInfo?.status === 0) {
      setDefaultName(userSettingsInfo.result?.nickName);
      setNickName(userSettingsInfo.result?.nickName);
      setWelcomeWords(userSettingsInfo.result?.welcomeWords);
      setDefaultWelcomeWords(userSettingsInfo.result?.welcomeWords);
    }
    getUserAgent()
    setInterval(getUserAgent, 300000)
  };
  const getUserAgent = async () => {
    //同步用户状态
    let UserAgentStatusInfo = await apiServices.getUserAgentStatus();
    if ((UserAgentStatusInfo && UserAgentStatusInfo.result.roleFlags & 2) === 2) {
      UserAgentStatusInfo.result.isAdmin = true;
      setisAdmin(true);
    }
    itemsState.items.forEach((item, index) => {
      if (item.index === UserAgentStatusInfo?.result.agentStatus) {
        setActiveIndex(item);
      }
    });
    if (UserAgentStatusInfo) {
      sessionStorage.setItem('user', JSON.stringify(UserAgentStatusInfo?.result));
      setAvatarUrl(UserAgentStatusInfo?.result.avatar);
    }
  };
  const saveUserSetting = async () => {
    if (welcomeWords && welcomeWords.length <= MAXIMUM_LENGTH_OF_MESSAGE) {
      setShowcard(false);
      let res = await apiServices.postUserSettings({ nickName, welcomeWords });
      setDefaultName(res.result.nickName);
      setWelcomeWords(res.result.welcomeWords);
    }
  };

  const isAuthenticated = useSelector(getIsAuthenticated);
  useEffect(() => {
    if (isAuthenticated) {
      loadPage()
    }
  }, [isAuthenticated]);

  return (
    <>
      <Stack horizontal horizontalAlign="end" className={chatHeaderBoxStyle}>
        {isAdmin && (
          <CommandButton
            className={selectStyle}
            text="客服管理"
            menuProps={menuProps}
            disabled={isMenuOpen1}
          />
        )}
        <CommandButton
          className={selectStyle}
          text="个人中心"
          menuProps={personalCenterItems}
          disabled={isMenuOpen2}
        />
        <CommandButton
          className={selectStyle}
          iconProps={activeIndex.iconProps}
          text={activeIndex.content}
          menuProps={itemsState}
          disabled={isMenuOpen3}
        />
      </Stack>

      <Modal
        titleAriaId={'title'}
        isOpen={showCard}
        onDismiss={() => { }}
        isBlocking={false}
        topOffsetFixed={true}
        containerClassName={contentStyles.spacecpPage}
      >
        <div className={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '18px' }}>
            <Stack horizontal horizontalAlign="start">
              <Text variant="xLarge" style={{ marginLeft: '0px' }}>
                个人中心
              </Text>
            </Stack>
            <Stack horizontal horizontalAlign="end">
              <CloseIcon
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setShowcard(false);
                }}
              />
            </Stack>
          </div>
          <Stack horizontal verticalAlign="center">
            <Avatar image={avatarUrl || Component} name={nickName} size="large" />
            <div style={{ height: '100%' }}>
              <div>
                <Text variant="xLarge" style={{ marginLeft: '12px' }}>
                  {nickName}
                </Text>
              </div>
              {isAdmin && (
                <div>
                  {' '}
                  <Text
                    variant="tiny"
                    style={{
                      marginLeft: '12px',
                      padding: '2px 6px',
                      backgroundColor: '#E8EBFA',
                      color: '#5B5FC7',
                      borderRadius: '5px'
                    }}
                  >
                    管理员
                  </Text>
                </div>
              )}
            </div>
          </Stack>

          <Stack grow>
            <TextField
              className={textStyle}
              label="昵称"
              placeholder="你的名字"
              defaultValue={nickName}
              onChange={(e: any, val: any) => {
                setNickName(val);
              }}
              onBlur={() => {
                setIsBlur(true);
              }}
              onFocus={() => {
                setIsBlur(false);
              }}
            />
            {isBlur && !nickName && <span style={{ color: '#C4314B', marginTop: '0px', borderTop: 'solid' }}>必填</span>}
            <TextField
              className={textStyle}
              label="欢迎语"
              placeholder="让用户认识你一下吧！"
              multiline
              resizable={false}
              defaultValue={welcomeWords}
              onChange={(e: any, val: any) => {
                setWelcomeWords(val);
              }}
            />
            {welcomeWords?.length > MAXIMUM_LENGTH_OF_MESSAGE && (
              <Text style={{ color: '#C4314B', borderTop: 'solid 3px #C4314B' }}> 最多{MAXIMUM_LENGTH_OF_MESSAGE}字</Text>
            )}
            {welcomeWords?.length < 10 && welcomeWords?.length !== 0 && (
              <Text style={{ color: '#C4314B', borderTop: 'solid 3px #C4314B' }}> 最少10字</Text>
            )}
          </Stack>
          <Stack
            horizontal
            horizontalAlign="end"
            verticalAlign="center"
            style={{ marginTop: '40px', marginBottom: '62px' }}
          >

            <PrimaryButton
              className={chatBtn}
              disabled={(welcomeWords && 9 < welcomeWords.length && welcomeWords.length <= MAXIMUM_LENGTH_OF_MESSAGE) ? false : true}
              style={{ border: '1px solid #E1DFDD' }}
              onClick={() => saveUserSetting()}
            >
              保存
            </PrimaryButton>
          </Stack>
        </div>
      </Modal>
    </>
  );
};
